// extracted by mini-css-extract-plugin
export default {"ChangeLanguageForm":"ChangeLanguageForm_ChangeLanguageForm__2hLkF","ChangeAlert":"ChangeLanguageForm_ChangeAlert__EmEl1","FormButtons":"ChangeLanguageForm_FormButtons__9gw+D"};